export var TrackingType;
(function (TrackingType) {
    TrackingType[TrackingType["Tracked"] = 0] = "Tracked";
    TrackingType[TrackingType["Manual"] = 1] = "Manual";
})(TrackingType || (TrackingType = {}));
//# sourceMappingURL=trackingType.enum.js.map